module.exports = __webpack_public_path__ + "static/media/matrix.efacff66.png";